import React, { PropsWithChildren } from 'react';
import bem from '../../../lib/bemUtils/bem';

type PaddingContainerModifier = 'no-padding-top' | 'no-padding-right' | 'no-padding-bottom' | 'no-padding-left';

type BaseProps = {
  modifier?: PaddingContainerModifier;
};

type DivProps = BaseProps & {
  children: React.ReactNode;
};

type SpanProps = BaseProps & {
  children: React.ReactNode;
};

export function PaddingContainerDiv({ modifier, children }: PropsWithChildren<DivProps>) {
  return <div className={bem('padding-container', modifier)}>{children}</div>;
}

export function PaddingContainerSpan({ modifier, children }: PropsWithChildren<SpanProps>) {
  return <span className={bem('padding-container', modifier)}>{children}</span>;
}
